module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/assessment_achievements/5@2x_227fcd4f1e9eea882a4110c59b4c68af.png";